module.exports = __webpack_public_path__ + "img/bag.783c09f5.png";